/* BOコード */
export default {
    // ベネフィットステーション
    BS: "BS"
}